// Import logo
import logo from './logo.png'

// Import all puppy images
import zeus from './zeus.jpg'
import athena from './athena.jpg'
import maximus from './maximus.jpg'
import luna from './luna.jpg'
import thor from './thor.jpg'
import bella from './bella.jpg'
import apollo from './apollo.jpg'  // Updated to JPG
import venus from './venus.jpg'    // Updated to JPG
import diana from './diana.jpg'    // Updated to JPG
import hercules from './hercules.jpg' // Updated to JPG
import caesar from './caesar.jpg'  // Updated to JPG
import cleopatra from './cleopatra.jpg'
import titan from './titan.jpg'
import adult from './adult.jpg'
import heroCaneCorsso from './hero-cane-corso.jpg'
import celia from './celia.jpg'
import rhodes from './rhodes.jpg'
import dan from './dan.jpg'
import thor1 from './Thor1.jpg'
import bruno1 from './Bruno1.jpg'
import rex1 from './Rex1.jpg'
import luna1 from './Luna1.jpg'
import channel1 from './Channel1.jpg'
import rosie1 from './Rosie1.jpg'
import coco1 from './Coco1.jpg'

// Export all images
export {
  logo,
  zeus,
  athena,
  maximus,
  luna,
  thor,
  bella,
  apollo,
  venus,
  diana,
  hercules,
  caesar,
  cleopatra,
  titan,
  adult,
  heroCaneCorsso,
  celia,
  dan,
  rhodes,
  thor1,
  bruno1,
  rex1,
  luna1,
  channel1,
  rosie1,
  coco1
}

// Create a map for easy access
export const puppyImages = {
  zeus,
  athena,
  maximus,
  luna,
  thor,
  bella,
  apollo,
  venus,
  diana,
  hercules,
  caesar,
  cleopatra,
  titan,
  celia,
  dan,
  rhodes,
  thor1,
  bruno1,
  rex1,
  luna1,
  channel1,
  rosie1,
  coco1
}
